import React, { useState, useEffect } from 'react';
import { TextField, Typography, Container, Card, IconButton, MenuItem, Table, Hidden, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery, Button, Box, Toolbar, CircularProgress, List, ListItem, ListItemIcon, ListItemText, ListItemAvatar, Avatar, Popover, } from "@mui/material";
import apiRequest from '../../functions/api';
import { useSessionStorage } from '../../utils/hooks';
import { LOCAL_STORAGE_KEY } from '../../constants/localStorage';
import Page from '../shared/components/PageComponent';
import Layout from '../shared/components/LayoutComponent';
import { useTranslation } from 'react-i18next';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import LastPageIcon from '@mui/icons-material/LastPage';
import { pad } from '../../functions/default';
import { withStyles } from '@mui/styles';
import { CheckBox, CheckBoxOutlineBlank, Filter, Filter1, FilterList } from '@mui/icons-material';
import axios from 'axios';
import { API_BASE_URL } from '../../constants/apiConstants';
import { useMessage } from '../../context/message-context';
import openFile from '../shared/functions/download';
import {FullPageSpinner, getMonthName} from '../lib';
const styles = (theme) => ({
  avatar: {
    color: theme.palette.getContrastText(theme.palette.secondary.main),
    backgroundColor: theme.palette.secondary.main,
  }
});
const Auswertungsarchiv = ({ client, classes }) => {
  const [month, setMonth] = useState('');
  const [year, setYear] = useState('');
  const [filter, setFilter] = useState('');
  const [typeFilters, setTypeFilters] = useState([]);
  const [zeitraum, setZeitraum] = useState();
  const [anchorEl, setAnchorEl] = useState(null);
  const [files, setFiles] = useState([]);
  const [filteredFiles, setFilteredFiles] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [fileIsLoading, setFileIsLoading] = useState(false);
  const [accessToken,] = useSessionStorage(LOCAL_STORAGE_KEY.accessToken);
  const { t } = useTranslation();
  const {showInfoMessage, showErrorMessage} = useMessage();
  useEffect(() => {
    loadFiles(zeitraum);
  }, [])
  useEffect(() => {
    var tmpFiles = files.filter((file) => {
      var showFile = false;
      var usesFilter = false;
      typeFilters.forEach(element => {
        if (element.active === true) {
          usesFilter = true;
          return
        }
      });
      if (!usesFilter) return(true);
      typeFilters.forEach(element => {
        if (element.key === file.type) {
          if (element.active === true) {
            showFile = true;
            return
          }
        }
      });
      return (showFile);
    }
    )
    tmpFiles = tmpFiles.filter((element) => element.name.toLowerCase().includes(filter.toLowerCase()))
    setFilteredFiles(tmpFiles);
  }, [filter, typeFilters, files])
  const loadFiles = (timePeriod) => {
    setIsLoading(true);
    const payload = {
      "mandant": client,
      "program": "AWARCH",
      "statement": "LADEN",
      "zeitraum": timePeriod
    }
    const headers = {
      "Authorization": "Bearer " + accessToken,
    }
    apiRequest('POST', 'daten', payload, headers, filesCb, errorCb);
  }
  const filesCb = (response) => {
    setIsLoading(false);
    if (response.status === 200) {
      setFiles(response.data.files);
      setZeitraum(response.data.year + response.data.month);
      setYear(response.data.year);
      setMonth(response.data.month);
        setTypeFilters(response.data.filters)
    } else {
      showErrorMessage(response.data.message);
    }
  }
  const errorCb = () => {
    setIsLoading(false);
    showErrorMessage(t("Verbindung fehlgeschlagen"));
  }
  const handleFilterChange = (e) => {
    setFilter(e.target.value);
  }

  const previousMonth = () => {
    var newMonth = '';
    var newYear = year;
    if (month === '01') {
      newMonth = '12';
      newYear = String(Number(year) - 1);
    } else {
      console.log(pad(Number(month) - 1, 2));
      newMonth = pad(String(Number(month) - 1), 2);
    }
    loadFiles(newYear+newMonth);
    setZeitraum(newYear+newMonth);
    setYear(newYear);
    setMonth(month);
  }
  const nextMonth = () => {
    var newMonth = '';
    var newYear = year;
    if (month === '12') {
      newMonth = '01';
      newYear = String(Number(year) + 1);
    } else {
      console.log(pad(Number(month) + 1, 2));
      newMonth = pad(String(Number(month) + 1), 2);
    }
    loadFiles(newYear+newMonth);
    setZeitraum(newYear+newMonth);
    setYear(newYear);
    setMonth(month);
  }
  const previousYear = () => {
    var newYear = String(Number(year) - 1);
    setYear(newYear);
    setZeitraum(newYear+month);
    loadFiles(newYear+month);
  }
  const nextYear = () => {
    var newYear = String(Number(year) + 1);
    setYear(newYear);
    setZeitraum(newYear+month);
    loadFiles(newYear+month);
  }
  const handleFilterClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleFilterClose = () => {
    setAnchorEl(null);
  };

  const closeModal = () => {
    setIsLoading(false);
  }
  const downloadFile = (key) => {
    setFileIsLoading(true);
    const payload={
      "mandant": client, 
      "program": "AWARCH",
      "statement": "DATEI_LADEN",
      "datei": filteredFiles[key].key,
    }
    const headers={
        "Authorization": "Bearer "+accessToken,
        "Accept": "application/pdf"
    }
    axios.post(API_BASE_URL+'daten', payload, {headers: headers, responseType: 'blob'})
      .then((response) => {
        console.log(response);
        var fileName = filteredFiles[key].name+filteredFiles[key].type;
        var contentFile = response.data;
        const mimeType = response.headers['content-type'] || 'application/pdf'
        openFile(fileName, contentFile, mimeType);
        closeModal();
        setFileIsLoading(false);
      })
      .catch(async function (error) {
        setFileIsLoading(false);
        if (error.response.data instanceof Blob) {
          const blob = new Blob([error.response?.data]);
          const data = await blob.text();
          const { message} = JSON.parse(data);
          showInfoMessage(message);
          
        } else {
          showErrorMessage(t("Ein Fehler ist aufgetreten. Bitte versuchen Sie den download erneut."));
        }
        closeModal();
      });
  }

  const handleFileClick = (e) => {
    downloadFile(e);
  }
  const handleTypeFilterClick = (filterIndex) => {
    var tmpTypeFilters = typeFilters.map((element) => element);
    if (typeFilters[filterIndex].active === true) {
      tmpTypeFilters[filterIndex].active = false;
    } else {
      tmpTypeFilters[filterIndex].active = true;
    }
    console.log(tmpTypeFilters);
    setTypeFilters(tmpTypeFilters);
  }
  const filterOpen = Boolean(anchorEl);
  const id = open ? 'filter-popover' : undefined;
  return (
    <Page>
      <Layout>
        <Box p={2} pb={0}>
          <Toolbar >
            <IconButton onClick={() => previousYear()}><FirstPageIcon /></IconButton>
            <IconButton onClick={() => previousMonth()}><NavigateBeforeIcon /></IconButton>
            <Box style={{ flexGrow: 1 }}></Box>
            <Typography variant="h5" >{getMonthName(Number(month)-1)} {year}</Typography>
            {isLoading ? <CircularProgress /> : <CircularProgress style={{ opacity: 0 }} />}
            <Box style={{ flexGrow: 1 }}></Box>
            <IconButton onClick={() => nextMonth()}><NavigateNextIcon /></IconButton>
            <IconButton onClick={() => nextYear()}><LastPageIcon /></IconButton>
          </Toolbar>
        </Box>
        <Box p={2}>
          <Toolbar >
            <TextField autoFocus={!Boolean(window.cordova)} label={t('Suche')} color="primary" variant="outlined" value={filter} onChange={handleFilterChange} fullWidth></TextField>
            <Box pl={2}>
              <IconButton aria-describedby={id} onClick={handleFilterClick}><FilterList /></IconButton>
              <Popover
                id={id}
                open={filterOpen}
                anchorEl={anchorEl}
                onClose={handleFilterClose}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'center',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'center',
                }}
              >
                <Box p={2} pb={0}>
                  <Typography variant="h5">{t("Filter")}</Typography>
                </Box>
                <List>
                  {typeFilters?.length > 0 ? typeFilters.map((typeFilter, index) => {
                    return (
                      <ListItem key={typeFilter.key} button onClick={() => handleTypeFilterClick(index)}>
                        <ListItemIcon>{typeFilter.active ? <CheckBox /> : <CheckBoxOutlineBlank />}</ListItemIcon>
                        <ListItemText primary={typeFilter.key} />
                      </ListItem>
                    )
                  })
                  :
                  <ListItem key="noFilters">
                  <ListItemText primary={t('Keine Filtermöglichkeiten')} />
                </ListItem>
                }
                </List>
              </Popover>
            </Box>
          </Toolbar>
        </Box>
        <List>
          {filteredFiles?.length > 0 ? 
            filteredFiles.map((file, count) => {
            return (
              <ListItem key={file.key} button onClick={() => handleFileClick(count)}>
                <ListItemAvatar><Avatar className={classes.avatar}>{file.type.replace('.', '')}</Avatar></ListItemAvatar>
                <ListItemText primary={file.name} />
              </ListItem>
            )
          })
        :
        <ListItem key="noFile">
          <ListItemAvatar></ListItemAvatar>
          <ListItemText primary="Keine Datei gefunden" />
        </ListItem>
        }
        </List>
      </Layout>
      {fileIsLoading && <FullPageSpinner/>}
    </Page>
  )
}
export default withStyles(styles)(Auswertungsarchiv);
